import { render } from "./ForgotPassword.vue?vue&type=template&id=1388a4b7&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=1388a4b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1388a4b7"

export default script